<template>
  <div>
    <v-dialog
      v-model="$store.getters.getModalBaixaContaReceber"
      persistent
      :overlay="$store.getters.getOverlay"
      max-width="720px"
    >
      <v-card>
        <v-card-title>Efetuar Baixa</v-card-title>
        <v-card-text>
          <v-form class="px-5" ref="formBaixaContaReceber">
            <v-layout row wrap>
              <v-flex xs12 md12>
                <v-select
                  class="mt-3"
                  :items="getFormasPagamento"
                  item-text="nome"
                  item-value="id"
                  v-model="pagamento.forma_pagamento_id"
                  label="Forma de Pagamento"
                  outlined
                  dense
                ></v-select>
              </v-flex>
              <v-flex xs12 md12>
                <v-text-field
                  label="Valor Pago"
                  id="id"
                  v-model="pagamento.valor_pago"
                  outlined
                  dense
                  v-mask="[
                    '#,##',
                    '##,##',
                    '###,###',
                    '#.###,##',
                    '##.###,##',
                    '###.###,##',
                  ]"
                  @keyup.enter="modalConfirmacaoBaixa=true, calculaTroco()"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="default"
            @click="setModalBaixaContaReceber(false)"
            outlined
            >Voltar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn color="success" outlined @click="modalConfirmacaoBaixa = true, calculaTroco()"
            >Salvar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="modalConfirmacaoBaixa"
      persistent
      :overlay="false"
      max-width="500px"
      transition="dialog-transition"
    >
      <v-card outline>
        <v-card-title> Baixar </v-card-title>
        <v-card-text>
          <h1 align="center" v-if="this.pagamento.troco > 0">TROCO: {{ $helper.formatReal(parseFloat(this.pagamento.troco)) }}</h1>
          <h3 align="center" class="mt-4">Confirma baixa?</h3>
        </v-card-text>
        <v-card-actions>
          <v-btn color="default" outlined @click="modalConfirmacaoBaixa = false"
            >Voltar</v-btn
          >
          <v-spacer></v-spacer>
          <v-btn
            color="success"
            outlined
            @click="_baixarContaReceber()"
            >Sim</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      modalConfirmacaoBaixa: false,
      pagamento: {
        forma_pagamento_id: 1,
        valor_pago: "",
        troco: 0
      },
    };
  },
  watch: {
    getModalBaixaContaReceber(){
      if(this.getModalBaixaContaReceber == true){
        this.pagamento = {
          forma_pagamento_id: 1,
          valor_pago: "",
          troco: 0
        }
      }
    }
  },
  computed: {
    ...mapGetters([
      "getModalBaixaContaReceber",
      "getContaReceber",
      "getFormasPagamento",
    ]),
  },
  methods: {
    ...mapActions([
      "setModalBaixaContaReceber",
      "baixarContaReceber",
      "listarFormaPagamento",
    ]),

    _baixarContaReceber() {
      this.modalConfirmacaoBaixa = false;
      if(this.$refs.formBaixaContaReceber.validate() == false){
        return
      }
      
      this.baixarContaReceber({
        ...this.getContaReceber,
        forma_pagamento_id: this.pagamento.forma_pagamento_id,
        valor_pago: this.$helper.formatReal(this.$helper.cleanFormatReal(this.pagamento.valor_pago) - this.pagamento.troco),
      });
    },
    calculaTroco(){
      if(this.$helper.cleanFormatReal(this.pagamento.valor_pago) > this.$helper.cleanFormatReal(this.getContaReceber.valor) - this.$helper.cleanFormatReal(this.getContaReceber.valor_pago)){
          this.pagamento.troco = this.$helper.cleanFormatReal(this.pagamento.valor_pago) - (this.$helper.cleanFormatReal(this.getContaReceber.valor) - this.$helper.cleanFormatReal(this.getContaReceber.valor_pago))
      }
    }
    
  },
};
</script>